"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _menuBanners = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/menuBanners"));
var _cache = require("@deosite/helpers/cache");
var _prismicHelper = require("../prismicHelper");
var _prismicErrorHandle = _interopRequireDefault(require("@deosite/helpers/prismicErrorHandle"));
var filename = "menubanners";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedMenuBanners, _getLanguage, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: global.__appConfig__.prismicMenuBanners,
              lang: lang
            });
          case 12:
            response = _context.sent;
            mappedMenuBanners = (0, _menuBanners["default"])(response);
            _context.next = 16;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, ".json"),
              result: mappedMenuBanners
            });
          case 16:
            return _context.abrupt("return", mappedMenuBanners);
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](9);
            _getLanguage = (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            }), _cacheFileExist = _getLanguage.cacheFileExist, _cachedRequest = _getLanguage.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 24;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 24:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - list"));
          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 19]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;